import { ColDef, ICellRendererParams } from "ag-grid-community";
import { MoneyCellRenderer } from "../../column-def-cell-renderers/money/MoneyCellRenderer";

export const k8sMonthlyPriceColumnDef: ColDef = {
  field: "resource.total_monthly_cost",
  headerName: "Monthly Price",
  headerTooltip:
    "Monthly prices are calculated based on the on-demand list price of each resource.",
  cellRenderer: ({ data }: ICellRendererParams) => {
    return <MoneyCellRenderer money={data?.resource?.total_monthly_cost} />;
  },
};
